import { client } from './auth';
//약관 가져오기
export async function getTerms(type: string) {
  return await client.get(`/terms?termsTypes=${type}`);
}

// 카테고리 조회
export async function getSearchCategory(string: string) {
  return await client.get(`/categories?keyword=${string}`);
}
